@if (isCurrentUserAdmin()) {

@if (isLoading()) {
  <app-loader [overlay]="true" size="md" message="Loading reports…" />
}

<app-page-header title="Report Management"/>

<app-notification-dialog
  [visible]="isNotificationVisible()"
  [message]="notificationMessage()"
  [type]="notificationType()"
  (closed)="isNotificationVisible.set(false)" />

<main id="main-content" aria-labelledby="report-management-title"
  class="flex flex-col xl:flex-row gap-8 px-6 py-8 md:py-6 bg-main-bg min-h-[calc(100vh-200px)] max-w-[1600px] mx-auto w-full">
  <div class="xl:flex-[2] flex flex-col gap-8">
    <app-card-panel title="Search Report">
      <div class="px-8 py-4" role="search" (keydown)="onSearchKeydown($event)">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4.5 items-end">
          <div class="w-full">
            <label for="search-report-name" class="block text-[12px] font-bold text-slate-900 mb-2">Report Name</label>
            <input id="search-report-name" type="text" [(ngModel)]="searchCriteria.reportName"
              aria-label="Filter by Report Name"
              class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-600" />
          </div>
          <div class="w-full">
            <label for="search-report-id" class="block text-[12px] font-bold text-slate-900 mb-2">Report ID</label>
            <input id="search-report-id" type="text" [(ngModel)]="searchCriteria.reportId"
              aria-label="Filter by Report ID"
              class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all placeholder:text-slate-600" />
          </div>

          <div class="w-full ">
            <label for="search-institution" class="block text-[12px] font-bold text-slate-900 mb-2 ">Institution</label>
            <div class="relative">
              <select id="search-institution" [(ngModel)]="searchCriteria.institution"
                aria-label="Filter by Institution"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.institution ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                @for (instName of allAvailableInstitutions(); track instName) {
                <option [value]="instName">{{ instName }}</option>
                }
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div class="w-full relative">
            <label for="search-active" class="block text-[12px] font-bold text-slate-900 mb-2 ">Active</label>
            <div class="relative">
              <select id="search-active" [(ngModel)]="searchCriteria.active" aria-label="Filter by Active Status"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.active ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                <option value="Yes">Active</option>
                <option value="No">Inactive</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="w-full relative">
            <label for="search-report-type" class="block text-[12px] font-bold text-slate-900 mb-2">Report Type</label>
            <div class="relative">
              <select id="search-report-type" [(ngModel)]="searchCriteria.reportType" aria-label="Filter by Report Type"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.reportType ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                <option value="RLS">RLS</option>
                <option value="Non-RLS">Non-RLS</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="w-full relative">
            <label for="search-internal" class="block text-[12px] font-bold text-slate-900 mb-2">Internal Report</label>
            <div class="relative">
              <select id="search-internal" [(ngModel)]="searchCriteria.internalReport"
                aria-label="Filter by Internal Report"
                class="w-full px-4 py-1 text-sm border border-slate-500 rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none"
                [ngClass]="searchCriteria.internalReport ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'">
                <option value="">--Please Select--</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500 pointer-events-none"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <div class="md:col-span-2 lg:col-span-3 flex justify-end gap-3 mt-2">
            <app-button label="Reset" ariaLabel="Reset Search" (clicked)="resetSearch()" />
            <app-button label="Search" ariaLabel="Search Reports" (clicked)="onSearch()" />
          </div>
        </div>
      </div>
    </app-card-panel>

    <app-data-table title="Report List" [columns]="tableColumns" [data]="paginatedReports()" trackByKey="reportId"
      [selectedItem]="selectedReport()" selectedKey="reportId" [currentPage]="currentPage()" [totalPages]="totalPages()"
      [totalItems]="filteredReports().length" [pageSize]="pageSize" itemLabel="reports"
      (rowClick)="onSelectReport($event)" (deleteClick)="onDeleteReport($event)" (pageChange)="onPageChange($event)">
          <ng-template #cellTemplate let-item let-column="column">
            @switch (column) {

            @case ('reportName') {
              <div class="block w-full truncate whitespace-nowrap text-[12px] font-bold text-slate-700" [attr.title]="item.reportName">
                {{ item.reportName }}
              </div>
            }

            @case ('reportType') {
              <span
                class="block w-full truncate whitespace-nowrap text-[11px] font-bold uppercase"
                [class]="item.reportType === 'RLS' ? 'text-primary' : 'text-slate-600'"
                [attr.title]="item.reportType">
                {{ item.reportType }}
              </span>
            }

            @case ('active') {
              <div class="flex items-center justify-center gap-2">
                <span
                  class="text-[11px] font-bold uppercase"
                  [class]="item.active === 'Yes' ? 'text-emerald-600' : 'text-slate-600'">
                  {{ item.active }}
                </span>
              </div>
            }

            @case ('internalReport') {
              <span
                class="block w-full truncate whitespace-nowrap text-[11px] font-bold uppercase"
                [class]="item.internalReport === 'Yes' ? 'text-primary' : 'text-slate-600'"
                [attr.title]="item.internalReport">
                {{ item.internalReport }}
              </span>
            }

            }
          </ng-template>
    </app-data-table>
  </div>

  <div
    class="xl:flex-[2] xl:self-start bg-white rounded-2xl shadow-sm border border-slate-500 flex flex-col overflow-hidden w-full max-w-full lg:max-w-2xl xl:max-w-none mx-auto">
    <div
      class="px-8 py-2 border-b border-slate-400 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-[#f8fafc]">
      <div>
        <h2 class="text-[18px] font-bold text-slate-800">Maintain Reports</h2>
      </div>

      <div class="flex items-center gap-3">
        <app-button label="Add Report" ariaLabel="Add New Report" [disabled]="isEditReport()"
          (clicked)="onCreateReport()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
          </svg>
        </app-button>

        @if (selectedReport() || isAddReport()) {
        <app-button label="Edit Report" ariaLabel="Edit Report" [disabled]="isEditReport()" (clicked)="onEditReport()">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </app-button>
        }
      </div>
    </div>

    @if (selectedReport() || isAddReport()) {

    <div class="flex-1 overflow-y-auto px-8 py-8 space-y-4 transition-opacity" [class.opacity-80]="!isEditReport()"
      [class.pointer-events-none]="!isEditReport()" (keydown)="onFormKeydown($event)">
      <section>
        <div class="space-y-6">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">

            @if (selectedReport()?.reportId) {
            <div class="sm:col-span-2">
              <label class="block text-[12px] font-bold mb-2 text-slate-700">Report ID</label>
              <input type="text" [value]="selectedReport()?.reportId" readonly aria-label="Report ID"
                class="w-full px-4 py-1 text-[13px] border border-slate-300 rounded-xl bg-slate-100/50 text-slate-600 outline-none" />
            </div>
            }

            <div class="sm:col-span-2">
              <label for="form-report-name" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">Report Name <span class="text-red-500"
                  aria-hidden="true">*</span></label>
              <input id="form-report-name" type="text" [ngModel]="reportName()" (ngModelChange)="reportName.set($event)"
                [disabled]="!isEditReport()" aria-label="Report Name" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
            </div>

            <div>
              <label for="form-pbi-unit-id" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">PBI Unit ID <span class="text-red-500"
                  aria-hidden="true">*</span></label>
              <input id="form-pbi-unit-id" type="text" [ngModel]="pbiUnitId()" (ngModelChange)="pbiUnitId.set($event)"
                [disabled]="!isEditReport()" aria-label="PBI Unit ID" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
            </div>
            <div>
              <label for="form-pbi-workspace" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">PBI Workspace <span class="text-red-500"
                  aria-hidden="true">*</span></label>
              <input id="form-pbi-workspace" type="text" [ngModel]="pbiWorkspace()"
                (ngModelChange)="pbiWorkspace.set($event)" [disabled]="!isEditReport()" aria-label="PBI Workspace"
                required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
            </div>
            <div>
              <label class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">Report Type</label>
              <div class="flex rounded-xl border overflow-hidden bg-slate-50 p-0.5 h-[30px] transition-colors"
                role="group" aria-label="Report Type Selection" [class.pointer-events-none]="!isEditReport()"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'">
                <button (click)="reportType.set('RLS')" [attr.aria-pressed]="reportType() === 'RLS'"
                  class="flex-1 px-4 py-0.5 text-[11px] font-black uppercase tracking-wider rounded-lg transition-all"
                  [class]="reportType() === 'RLS' ? 'bg-primary shadow-sm text-white' : (isEditReport() ? 'text-slate-600 hover:text-slate-800' : 'text-slate-500')">
                  RLS
                </button>
                <button (click)="reportType.set('Non-RLS')" [attr.aria-pressed]="reportType() === 'Non-RLS'"
                  class="flex-1 px-4 py-0.5 text-[11px] font-black uppercase tracking-wider rounded-lg transition-all"
                  [class]="reportType() === 'Non-RLS' ? 'bg-primary shadow-sm text-white' : (isEditReport() ? 'text-slate-600 hover:text-slate-800' : 'text-slate-500')">
                  Non-RLS
                </button>
              </div>
            </div>
            <div>
              <label for="form-active" class="block text-[12px] font-bold mb-6.5 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'"></label>
            <div class="flex items-center justify-between gap-3 h-[30px] px-3 rounded-xl border bg-slate-50/30 transition-colors" 
              [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'">
              <span class="text-[13px] font-semibold" [class]="isEditReport() ? 'text-slate-900' : 'text-slate-800'">Active</span>
              <label class="relative inline-flex items-center" [class.cursor-pointer]="isEditReport()">
                <input id="active-toggle" type="checkbox" [ngModel]="isActive()" (ngModelChange)="isActive.set($event)"
                  [disabled]="!isEditReport()" class="sr-only peer" />
                <span
                  class="relative w-8 h-4 bg-slate-200 rounded-full shadow-inner peer-checked:bg-primary after:absolute after:top-[2px] after:left-[2px] after:w-3 after:h-3 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4"></span>
              </label>
            </div>
            </div>
            @if (reportType() === 'RLS') {
            <div>
              <label for="form-pbi-dataset" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">PBI Dataset</label>
              <input id="form-pbi-dataset" type="text" [ngModel]="pbiDataset()" (ngModelChange)="pbiDataset.set($event)"
                [disabled]="!isEditReport()" aria-label="PBI Dataset" required aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none placeholder:text-slate-600 disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
            </div>
            
            <div>
              <label for="form-role" class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">Role</label>
              <div class="relative">
              <input id="form-role" type="text" [ngModel]="role()" (ngModelChange)="role.set($event)" [disabled]="!isEditReport()"
                aria-label="Role"  aria-required="true"
                class="w-full px-4 py-1 text-[13px] border rounded-xl bg-white focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
              </div>
            </div>
            }

          </div>
        </div>
      </section>

  <!-- Row 1: Active, Internal Report, Filter Pane -->
  <section class="grid grid-cols-1 sm:grid-cols-3 gap-3 py-2">
    <div class="flex items-center justify-between gap-3 h-[30px] px-3 rounded-xl border bg-slate-50/30 transition-colors border-slate-500">
      <span class="text-[13px] font-semibold whitespace-nowrap"
        [class]="isEditReport() ? 'text-slate-900' : 'text-slate-800'">
        Nav Content Pane
      </span>

      <label class="relative inline-flex items-center" [class.cursor-pointer]="isEditReport()">
        <input id="Nav-Content-toggle" type="checkbox" [ngModel]="navContentPaneEnabled()" (ngModelChange)="navContentPaneEnabled.set($event)"
          [disabled]="!isEditReport()" class="sr-only peer" />
        <span
          class="relative w-8 h-4 bg-slate-200 rounded-full shadow-inner peer-checked:bg-primary after:absolute after:top-[2px] after:left-[2px] after:w-3 after:h-3 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4"></span>
      </label>
    </div>
    <div class="flex items-center justify-between gap-3 h-[30px] px-3 rounded-xl border bg-slate-50/30 transition-colors"
      [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'">
      <span class="text-[13px] font-semibold" [class]="isEditReport() ? 'text-slate-900' : 'text-slate-800'">Internal
        Report</span>
      <label class="relative inline-flex items-center" [class.cursor-pointer]="isEditReport()">
        <input id="internal-report-toggle" type="checkbox" [ngModel]="isInternalReport()" (ngModelChange)="isInternalReport.set($event)"
          [disabled]="!isEditReport()" class="sr-only peer" />
        <span
          class="relative w-8 h-4 bg-slate-200 rounded-full shadow-inner peer-checked:bg-primary after:absolute after:top-[2px] after:left-[2px] after:w-3 after:h-3 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4"></span>
      </label>
    </div>

    <div class="flex items-center justify-between gap-3 h-[30px] px-3 rounded-xl border bg-slate-50/30 transition-colors"
      [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'">
      <span class="text-[13px] font-semibold" [class]="isEditReport() ? 'text-slate-900' : 'text-slate-800'">Filter
        Pane</span>
      <label class="relative inline-flex items-center" [class.cursor-pointer]="isEditReport()">
        <input id="filter-pane-toggle" type="checkbox" [ngModel]="filterPaneEnabled()" (ngModelChange)="filterPaneEnabled.set($event)"
          [disabled]="!isEditReport()" class="sr-only peer" />
        <span
          class="relative w-8 h-4 bg-slate-200 rounded-full shadow-inner peer-checked:bg-primary after:absolute after:top-[2px] after:left-[2px] after:w-3 after:h-3 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4"></span>
      </label>
    </div>

  </section>

  <!-- Row 2: Page Name + Nav Content Pane -->
  <section class="grid grid-cols-1 sm:grid-cols-[1fr_1fr] gap-3 items-end py-2">

    <div>
      <label for="form-page-name" class="block text-[12px] font-bold mb-2 transition-colors"
        [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">
        Page Name
      </label>

      <input id="form-page-name" type="text" [ngModel]="pageName()" (ngModelChange)="pageName.set($event)"
        [disabled]="!isEditReport()"
        class="w-full px-4 py-1 text-[13px] border rounded-xl bg-slate-50/30 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none disabled:bg-slate-100/50 disabled:text-slate-500"
        [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'" />
    </div>
          <div>
              <label class="block text-[12px] font-bold mb-2 transition-colors"
                [class]="isEditReport() ? 'text-slate-900' : 'text-slate-700'">Page View</label>
              <div class="relative">
                <select id="form-page-view" [ngModel]="pageView()" (ngModelChange)="pageView.set($event)"
                  [disabled]="!isEditReport()" aria-label="Page View" required aria-required="true"
                  class="w-full px-4 py-1 pr-10 text-[13px] border rounded-xl focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all appearance-none disabled:bg-slate-100/50 disabled:text-slate-500 disabled:cursor-default"
                  [ngClass]="pageView() ? 'bg-primary/10 text-slate-900' : 'bg-white text-slate-700'"
                  [class]="isEditReport() ? 'border-slate-500' : 'border-slate-300'">
                  <option value="actualSize">ActualSize</option>
                  <option value="fitToPage">FitToPage</option>
                  <option value="fitToWidth">FitToWidth</option>
                </select>
                <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-500">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M19 9l-7 7-7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
              </div>
            </div>
  </section>
      <section>
        <div class="flex items-center gap-3 text-[11px] font-bold text-slate-600 uppercase tracking-widest mb-2">
          <div class="w-8 h-8 bg-slate-50 rounded-lg flex items-center justify-center">
            <svg class="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          Institution Assignment<span class="text-red-500" aria-hidden="true">*</span>
        </div>

        <app-institution-transfer-list
          [availableInstitutions]="availableInstitutions()"
          [assignedInstitutions]="assignedInstitutions()"
          [selectedAvailable]="selectedAvailable()"
          [selectedAssigned]="selectedAssigned()"
          [isEditable]="isEditReport()"
          idPrefix="report-management"
          (availableSelectedToggle)="toggleAvailableSelection($event)"
          (assignedSelectedToggle)="toggleAssignedSelection($event)"
          (moveToAssignedClick)="moveToAssigned()"
          (moveAllToAssignedClick)="moveAllToAssigned()"
          (moveAllToAvailableClick)="moveAllToAvailable()"
          (moveToAvailableClick)="moveToAvailable()"
          (availableKeydown)="onAvailableInstitutionsKeydown($event)"
          (assignedKeydown)="onAssignedInstitutionsKeydown($event)"
            (availableListBlur)="selectedAvailable.set([])"
            (assignedListBlur)="selectedAssigned.set([])" />
      </section>
    </div>

    @if (isEditReport()) {
    <div class="px-10 py-2 border-t border-slate-300 flex items-center justify-end gap-3 bg-slate-50/10">
      <app-button label="Cancel" (clicked)="onCancel()" />
      <app-button label="Save" [disabled]="!isFormValid()" (clicked)="onSave()" />
    </div>
    }
    }
  </div>
</main>
} @else {
<div class="flex items-center justify-center min-h-[calc(100vh-200px)]">
  <div class="text-center p-12 bg-white rounded-3xl shadow-xl border border-slate-300 max-w-md">
    <div class="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
      <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 15v2m0-6V9m0 12a9 9 0 110-18 9 9 0 010 18z" />
      </svg>
    </div>
    <h2 class="text-2xl font-black text-slate-800 mb-4">Access Denied</h2>
    <p class="text-slate-600 font-medium leading-relaxed mb-8">
      This screen is restricted to Admins only. Please contact your system administrator if you believe this is an
      error.
    </p>
    <button onclick="window.history.back()"
      class="px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95">
      Go Back
    </button>
  </div>
</div>
}

<app-confirm-dialog [visible]="showDeleteModal()"
  [message]="'Are you sure you want to delete Report: ' + (reportToDelete()?.reportName || '') + '?'"
  (confirmed)="confirmDelete()" (cancelled)="cancelDelete()" />